import { render, staticRenderFns } from "./Olapic.vue?vue&type=template&id=ac07cb7e&"
import script from "./Olapic.vue?vue&type=script&lang=js&"
export * from "./Olapic.vue?vue&type=script&lang=js&"
import style0 from "./Olapic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports